export default __webpack_public_path__ + "static/media/button_hover.e6da8898.mp3";